import Api from './api';

export default {
  getConfigs: () => Api.get('configs'),
};
